"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainForShefUrl = exports.SHORT_URL_PATH = void 0;
const Domains_1 = require("./Domains");
exports.SHORT_URL_PATH = 's';
const getDomainForShefUrl = (url) => {
    if (!url) {
        throw new Error(`Missing url!`);
    }
    if (url.includes('web.test.shef')) {
        return 'test.shef';
    }
    if (url.includes('localhost')) {
        return 'localhost';
    }
    return Domains_1.ACTUAL_DOMAIN;
};
exports.getDomainForShefUrl = getDomainForShefUrl;
//# sourceMappingURL=RouteUtils.js.map